import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api/client.js";
import type { FeatureReadinessState } from "../lib/diagnostics.js";

interface ReadinessFeatures {
  screenshots: FeatureReadinessState;
  email: FeatureReadinessState;
  billing: FeatureReadinessState;
  recurring: FeatureReadinessState;
  documents: FeatureReadinessState;
}

interface ReadinessResponse {
  ok: boolean;
  features: ReadinessFeatures;
  warnings: string[];
}

/**
 * Fetch /readiness features. Cached for 5 minutes (rarely changes at runtime).
 * Only fetches the feature readiness subset — not full infrastructure checks.
 */
export function useFeatureReadiness() {
  return useQuery<ReadinessFeatures | null>({
    queryKey: ["feature-readiness"],
    queryFn: async () => {
      try {
        const res = await apiGet<ReadinessResponse>("/readiness");
        return res.features;
      } catch {
        // Readiness endpoint may fail if server is degraded — don't crash the UI
        return null;
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
